import React from "react";
import styles from "./Features.module.css";
import Icon from "../common/Icon";
import { Reveal } from "../common/Reveal";

const FEATURES = [
  { icon: "Industrial", title: "Industrial Automation", text: "Aimed at increasing the accuracy and performance of processes and reducing the human interface." },
  { icon: "Robot", title: "Robotics", text: "We design and build custom robotic material handling and glue dispensing systems as per specifications." },
  { icon: "Machine", title: "Special Purpose Machines", text: "Tremendous scope for high volume production at low investment and at low cost of production." },
  { icon: "Mould", title: "Plastic Moulding", text: "Injection moulding, mould manufacturing, assembly & large scale production, and development of moulding techniques." },
];

export default function Features() {
  return (
    <section className={styles.features} id="products">
      <div className={styles.featuresGrid}>
        {FEATURES.map((f, i) => {
          const FeatureIcon = Icon[f.icon];
          return (
            <Reveal key={f.title} delay={i * 90} className={styles.featureCard}>
              <span className={styles.featureIcon}><FeatureIcon /></span>
              <h3 className={styles.featureTitle}>{f.title}</h3>
              <p className={styles.featureText}>{f.text}</p>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
